export enum PolicyType {
  none = 'None',
  custom = 'Custom',
  default = 'Default'
}
